// extracted by mini-css-extract-plugin
export var drawerContent = "_39-0";
export var valueBlock = "_39-1";
export var valueBlockFrom = "_39-2 _39-1";
export var valueBlockTo = "_39-3 _39-1";